// @flow

import React, { useCallback, useEffect, useRef } from "react";

import { connect } from "react-redux";

import className from "classnames";
import { CSSTransition } from "react-transition-group";

import { Translate } from "@quantum/i18n";
import { ClickOutside } from "@quantum/ui";

import { type ModoApp, MODO_APP_SERIES } from "../../../../../model";

import { type State, getModoApp } from "../../../../../state";

import "./filtro-ativos.css";

type Filtro = {
  traducao: string,
  chaveBusca: string,
};

const allFilters: Array<Filtro> = [
  {
    traducao: "Comum.Todos.Maiusculas",
    chaveBusca: "defaultSearch",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.fundo",
    chaveBusca: "fundoFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.acao",
    chaveBusca: "empresaAbertaAcaoFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.rendaFixa",
    chaveBusca: "rendaFixaFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.derivativos",
    chaveBusca: "derivativosFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.indices",
    chaveBusca: "indiceFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.benchmarkPersonalizado",
    chaveBusca: "benchmarksPersonalizadosFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.portfolio",
    chaveBusca: "portfolioFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.meusAtivos",
    chaveBusca: "ativoUsuarioFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.grupos",
    chaveBusca: "gruposFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.buscaAvancada",
    chaveBusca: "buscaAvancadaFiltroBusca",
  },
];

const allFiltersSeries: Array<Filtro> = [
  {
    traducao: "Comum.Todos.Maiusculas",
    chaveBusca: "defaultSearch",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.fundo",
    chaveBusca: "fundoFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.rpps",
    chaveBusca: "RPPSFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.acao",
    chaveBusca: "empresaAbertaAcaoFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.rendaFixa",
    chaveBusca: "rendaFixaFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.indices",
    chaveBusca: "indiceFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.benchmarkPersonalizado",
    chaveBusca: "benchmarksPersonalizadosFiltroBusca",
  },
  {
    traducao: "buscaGlobal.tipoAtivo.meusAtivos",
    chaveBusca: "ativoUsuarioFiltroBusca",
  },
];

type Props = {
  modoApp: ModoApp,
  filters?: Array<Filtro>,
  selectFilter: string => void,
  show: boolean,
  value: string,
  onHide: () => void,
};

const FiltroAtivos = ({
  modoApp,
  filters = modoApp === MODO_APP_SERIES ? allFiltersSeries : allFilters,
  selectFilter,
  show,
  value,
  onHide,
}: Props) => {
  const timer = useRef(null);

  const onClickFilter = useCallback(
    (event: SyntheticEvent<HTMLDivElement>) => {
      selectFilter(event.currentTarget.dataset.filter);
      timer.current = setTimeout(() => onHide(), 400);
    },
    [onHide, selectFilter]
  );

  useEffect(() => {
    if (show) {
      clearTimeout(timer.current);
    }
  }, [show]);

  return (
    <CSSTransition
      timeout={300}
      in={show}
      className="FiltroAtivos__transition"
      classNames="FiltroAtivos__transition"
      unmountOnExit
    >
      <ClickOutside onClickOutside={onHide}>
        <div className="FiltroAtivos">
          <ul className="FiltroAtivos__filtros">
            {filters.map((filter, index) => (
              <li
                key={index}
                className={className("FiltroAtivos__filtro", {
                  "FiltroAtivos__filtro--selected": filter.chaveBusca === value,
                })}
                onClick={onClickFilter}
                data-filter={filter.chaveBusca}
              >
                <Translate>{filter.traducao}</Translate>
              </li>
            ))}
          </ul>
        </div>
      </ClickOutside>
    </CSSTransition>
  );
};

export default connect((state: State, ownProps) => ({
  modoApp: getModoApp(state),
  ...ownProps,
}))(FiltroAtivos);
